var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSession = function SvgSession(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3B82F6",
    fillRule: "evenodd",
    d: "M1.5 9A5.5 5.5 0 0 1 7 3.5a.5.5 0 0 1 .5.5v4.5H12a.5.5 0 0 1 .5.5 5.5 5.5 0 0 1-11 0",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3B82F6",
    fillRule: "evenodd",
    d: "M8.5 2a.5.5 0 0 1 .5-.5A5.5 5.5 0 0 1 14.5 7a.5.5 0 0 1-.5.5H9a.5.5 0 0 1-.5-.5z",
    clipRule: "evenodd"
  })));
};
export default SvgSession;